import React, { useEffect, useState } from 'react';
import { useAuth } from '../../AuthProvider';
import { PERSONAL_WORKSPACE_ID, WorkspaceAPI } from '../../../utils/api';
import { storeHomeWorkspaceName } from '../../../utils/workspaceName';

export function SettingsWorkspaceName() {
  const { workspaceId, workspaces, renameWorkspace } = useAuth();
  const current = (workspaces || []).find((w) => w.id === workspaceId);
  const [name, setName] = useState(current?.name || '');
  const [status, setStatus] = useState('');

  useEffect(() => {
    setName(current?.name || '');
  }, [current?.name, workspaceId]);

  const save = async (event) => {
    event?.preventDefault?.();
    const trimmed = name.trim();
    if (!trimmed || trimmed === current?.name) return;
    setStatus('saving');
    try {
      if (workspaceId === PERSONAL_WORKSPACE_ID || !workspaceId) {
        storeHomeWorkspaceName(trimmed);
      }
      try {
        await WorkspaceAPI.rename(workspaceId || PERSONAL_WORKSPACE_ID, trimmed);
      } catch {
        // Staging may not have PATCH yet — local name still updates.
      }
      renameWorkspace?.(workspaceId || PERSONAL_WORKSPACE_ID, trimmed);
      setStatus('saved');
      window.setTimeout(() => setStatus(''), 1600);
    } catch (err) {
      setStatus(err?.message || 'Could not rename');
    }
  };

  return (
    <section className="settings-modal__section">
      <form className="settings-workspace-name" onSubmit={save}>
        <label className="settings-modal__label" htmlFor="workspace-name">
          Name
        </label>
        <p className="settings-modal__description">
          This is your brain. Rename it if you want.
        </p>
        <div className="settings-workspace-name__row">
          <input
            id="workspace-name"
            className="settings-people__field settings-people__input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            onBlur={save}
            maxLength={64}
          />
          <button
            type="submit"
            className="settings-modal__action-btn"
            disabled={!name.trim() || name.trim() === (current?.name || '')}
          >
            {status === 'saving' ? 'Saving…' : status === 'saved' ? 'Saved' : 'Save'}
          </button>
        </div>
      </form>
    </section>
  );
}
